import React from 'react';
import type { ComponentProps, ReactElement } from 'react';

import type { Blockquote as OriginalBlockquote } from '@atlaskit/renderer/nodes';

import type { LightNodeProps } from '../LightNodeObserver.ts';

export const Blockquote = ({
	children,
	lightNodeRef,
	localId,
}: ComponentProps<typeof OriginalBlockquote> & LightNodeProps): ReactElement => (
	<blockquote ref={lightNodeRef} data-local-id={localId}>
		{children}
	</blockquote>
);
